var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sanitizedValue !== '')?_c('span',[_c('b-icon-upc-scan'),_vm._v(" "+_vm._s(_vm.sanitizedValue)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }